import gql from "graphql-tag";

import { PRODUCT_THUMBNAIL, MOBILE_PRODUCT_THUMBNAIL } from "@components/ProductPage/ProductThumbnail/queries";

export const HOMEPAGE_COLLECTION_ID = gql`
  query homepageCollectionID {
    shop {
      homepageCollection {
        id
        name
        slug
			}
    }
  }
`;

export const HOMEPAGE_COLLECTION = gql`
  ${PRODUCT_THUMBNAIL}
  query homepageCollectionCollectionProducts($count: Int!) {
    shop {
      homepageCollection {
        id
        name
        slug
			}
      homepageCollectionProducts(count: $count){
        ...productThumbnail
      }
    }
  }
`;

export const MOBILE_HOMEPAGE_COLLECTION = gql`
  ${MOBILE_PRODUCT_THUMBNAIL}
  query mobileHomepageCollectionCollectionProducts($count: Int!) {
    shop {
      homepageCollection {
        id
        name
        slug
			}
      homepageCollectionProducts(count: $count){
        ...mobileProductThumbnail
      }
    }
  }
`;
